import { createFileRoute } from '@tanstack/react-router'
import BillingRunHistoryList from '@/pages/BillingRunHistory/BillingRunHistoryList'
import { RequirePermission } from '@/components/ui/require-permission'

export const Route = createFileRoute(
  '/_authenticated/operation/billing-run-history/'
)({
  component: () => (
    <RequirePermission permission='billing.run'>
      <BillingRunHistoryList />
    </RequirePermission>
  ),
})
